import { LocaleEnum as n } from "../../libs/types/dist/index11.mjs";
import { LanguageCodeEnum as a } from "../../libs/types/dist/index12.mjs";
import { localeLanguages as c } from "./locale-labels.mjs";
function L(o) {
  const e = Object.keys(n).find(
    (t) => n[t] === o
  );
  return e ? a[e] : a.ENGLISH;
}
function f(o) {
  const e = Object.keys(a).find(
    (t) => a[t] === o
  );
  return e ? n[e] : n.ENGLISH;
}
function i(o, e) {
  return e(c[o]);
}
export {
  L as getLanguageCodeByLocale,
  f as getLocaleByLanguageCode,
  i as getLocaleLanguage
};
